import { Component } from '@angular/core';

@Component({
    selector: 'disease-at-a-glance',
    templateUrl: './disease-at-a-glance.component.html',
    styleUrls: ['./disease-at-a-glance.component.scss'],
})
export class DiseaseAtAGlanceComponent {}
